import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "team-page flex flex-col align-start h-full" }
const _hoisted_2 = { class: "topbar w-full" }
const _hoisted_3 = { class: "actions flex gap-2" }
const _hoisted_4 = { class: "capacity w-[40px] h-[40px] flex items-center justify-center" }
const _hoisted_5 = { class: "resource-bar cursor-pointer w-full" }
const _hoisted_6 = { class: "left flex items-center justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "leftType flex items-center gap-[10px]"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "leftType flex items-center gap-[10px]"
}
const _hoisted_10 = { class: "filters" }
const _hoisted_11 = {
  key: 0,
  class: "value"
}
const _hoisted_12 = {
  key: 0,
  class: "value"
}
const _hoisted_13 = {
  key: 0,
  class: "value"
}
const _hoisted_14 = { class: "material px-[24px] w-full flex-1 min-h-0 overflow-hidden" }
const _hoisted_15 = { class: "multiple-choice" }

import { ref, computed, onMounted } from 'vue'
import { ElButton, ElIcon } from 'element-plus'
import { Search, Plus, ArrowDown, ArrowRight } from '@element-plus/icons-vue'
//@ts-ignore
import FolderListBase from '@/views/shared/components/FolderListBase.vue'
//@ts-ignore
import UploadDialog from '@/views/shared/components/UploadDialog.vue'
//@ts-ignore
import ResourceMasonry from '@/views/shared/components/ResourceMasonry.vue'
//@ts-ignore
import MultipleChoice from '@/views/shared/components/multipleChoice.vue'

import { getTagPage, getCategoryPage, getCategorySuffixes } from '@/api/ResourceMasonry'
import { getResourceCapacity } from '@/api/affairs'
import { multipleChoiceStore } from "@/stores/multipleChoice"

export default /*@__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {

const multipleChoice = multipleChoiceStore()
onMounted(() => {
    multipleChoice.clearSelected()
    getfilterPage()
    getCapacity()
})
const searchText = ref('')
const resources = ref<any[]>([])
const avatarStack = ref<string[]>([
    'https://file.aimano.xin/passport/system/dc1a6a7fb61647139a3d9f56c41726ff.png',
])
const types = ref(['全部', '模板', '素材'])
const scenes = ref([{ name: '全部', id: '' }])
const formats = ref(['全部'])
const tags = ref([{ name: '全部', id: '' }])

const activeTab = ref<'space' | 'fav' | 'trash'>('space')
const switchTab = (tab: 'space' | 'fav' | 'trash') => {
    activeTab.value = tab
    activeType.value = '全部'
    activeScenes.value = { name: '全部', id: '' }
    activeFormats.value = '全部'
    activeTags.value = []
    if (tab === 'space') {
        materialRef.value?.parentgetList?.({})
    }
}
const refresh = () => {
    materialRef.value?.parentgetList?.({})
    folderListRef.value?.refresh?.()
}
const activeType = ref('全部')
const activeScenes = ref({ name: '全部', id: '' })
const activeFormats = ref('全部')
const activeTags = ref<any[]>([])
const activeTagsLabel = computed(() => activeTags.value.length ? activeTags.value.map((it) => it.name).join(',') : '全部')
const typesVisible = ref(false)
const scenesVisible = ref(false)
const formatsVisible = ref(false)
const tagsVisible = ref(false)

const activeFolder = ref({})
const onFolderSelect = (f: any) => {
    activeFolder.value = f
    materialRef.value?.parentgetList?.({ currentFolder: f })
}
const materialRef = ref<any>(null)
const folderListRef = ref<any>(null)
const fileInput = ref<HTMLInputElement | null>(null)
const uploadVisible = ref(false)
const selectedFiles = ref<File[]>([])
const handleUpload = () => {
    fileInput.value?.click()
}
const onActionCommand = (cmd: string) => {
    if (cmd === 'upload') {
        fileInput.value?.click()
        return
    }
    if (cmd === 'folder') {
        folderListRef.value?.onCreateFolder?.()
        return
    }
}
const onFileChange = (e: Event) => {
    const fs = Array.from((e.target as HTMLInputElement).files || [])
    selectedFiles.value = fs
    uploadVisible.value = true
        ; (e.target as HTMLInputElement).value = ''
}
const onAddFiles = (fs: File[]) => { selectedFiles.value = [...selectedFiles.value, ...fs] }
const onRemoveFile = (i: number) => { selectedFiles.value.splice(i, 1) }
const onUploadConfirm = (payload: any) => {
    materialRef.value?.parentgetList?.()
    uploadVisible.value = false

}
const onUploadCancel = () => { uploadVisible.value = false }
const onTypeCommand = (v: string) => {
    console.log(v)
    activeType.value = v
    if (v == '素材') {
        materialRef.value?.parentgetList?.({ file_type: 2 })
    } else if (v == '模板') {
        materialRef.value?.parentgetList?.({ file_type: 1 })
    } else if (v == '全部') {
        materialRef.value?.parentgetList?.({ file_type: '' })
    }
}
const onSceneCommand = (v: { name: string; id: string }) => {
    activeScenes.value = v
    materialRef.value?.parentgetList?.({ category_id: v.id })
}
const onFormatCommand = (v: string) => {
    activeFormats.value = v
    materialRef.value?.parentgetList?.({ file_suffix: v })
}
const onTagCommand = (v) => {
    if (v.id == '') {
        activeTags.value = []
        return
    }
    const i = activeTags.value.findIndex((item: any) => item.id == v.id)
    if (i >= 0) {
        activeTags.value.splice(i, 1)
    } else {
        activeTags.value.push(v)
    }
    let ids = activeTags.value.map((item: any) => item.id).join(',')
    materialRef.value?.parentgetList?.({ tag_ids: ids })
}
const clearType = () => {
    activeType.value = '全部'
    materialRef.value?.parentgetList?.({ file_type: '' })
}
const clearScenes = () => {
    activeScenes.value = { name: '全部', id: '' }
    materialRef.value?.parentgetList?.({ category_id: '' })
}
const clearFormats = () => {
    activeFormats.value = '全部'
    materialRef.value?.parentgetList?.({ file_suffix: '' })
}
const clearTags = () => {
    activeTags.value = []
    materialRef.value?.parentgetList?.({ tag_ids: '' })
}
const clearSearch = () => {
    searchText.value = ''
    materialRef.value?.parentgetList?.({ search: '' })
}
const onSearchEnter = async () => {
    materialRef.value?.parentgetList?.({ search: searchText.value })
}
const remainingCapacity = ref(0)
const getCapacity = () => {
    getResourceCapacity({ corp_code: '' }).then(res => {
        if (res.data.code == 200) {
            let arr = res.data.data
            arr.prop = arr.used_capacity / arr.capacity
            remainingCapacity.value = arr
        }
    })
}
const getfilterPage = async () => {
    const res = await getTagPage({ owner_type: 'user', corp_code: '', page: 1, size: 100 })
    tags.value = [{ name: '全部', id: '' }, ...res.data.data.items.map((item: any) => ({ name: item.name, id: item.id }))]
    const res2 = await getCategoryPage({ owner_type: 'user', corp_code: '', page: 1, size: 100 })
    scenes.value = [{ name: '全部', id: '' }, ...res2.data.data.items.map((item: any) => ({ name: item.name, id: item.id }))]
    const res3 = await getCategorySuffixes({ owner_type: 'user', corp_code: '' })
    formats.value = ['全部', ...res3.data.data.items.map((item: any) => (item.file_suffix))]
    console.log(formats.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("span", { class: "team-name" }, "我的空间")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          placeholder: "搜索当前库",
          modelValue: searchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          class: "team-search",
          onKeyup: _withKeys(onSearchEnter, ["enter"]),
          clearable: "",
          onClear: clearSearch
        }, {
          suffix: _withCtx(() => [
            _createVNode(_unref(ElIcon), {
              class: "el-input__icon cursor-pointer",
              onClick: onSearchEnter
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dropdown, {
          trigger: "click",
          onCommand: onActionCommand
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "upload" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("上传文件", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "folder" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("创建文件夹", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(ElButton), {
              type: "primary",
              class: "upload-btn"
            }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createTextVNode("新增/上传 ", -1)),
                _createVNode(_unref(ElIcon), { class: "caret" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDown))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("input", {
          ref_key: "fileInput",
          ref: fileInput,
          type: "file",
          multiple: "",
          style: {"display":"none"},
          onChange: onFileChange,
          accept: ".png,.jpg,.jpeg,.webp,.gif"
        }, null, 544),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_progress, {
            type: "circle",
            percentage: ((remainingCapacity.value.prop || 0) * 100).toFixed(0),
            width: "40",
            "stroke-width": "4",
            color: "#2a66ff"
          }, null, 8, ["percentage"])
        ])
      ])
    ]),
    _withDirectives(_createVNode(FolderListBase, {
      ref_key: "folderListRef",
      ref: folderListRef,
      onSelect: onFolderSelect,
      "root-label": "我的空间"
    }, null, 512), [
      [_vShow, activeTab.value === 'space']
    ]),
    _createVNode(UploadDialog, {
      visible: uploadVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((uploadVisible).value = $event)),
      folder: activeFolder.value,
      files: selectedFiles.value,
      onAddFiles: onAddFiles,
      onConfirm: onUploadConfirm,
      onCancel: onUploadCancel,
      currentTeam: _ctx.currentTeam,
      onRemoveFile: onRemoveFile
    }, null, 8, ["visible", "folder", "files", "currentTeam"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (activeTab.value === 'space' || activeTab.value === 'fav')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (it) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["type-item filter-ref", { 'typeActive': activeType.value === it }]),
                  key: it,
                  onClick: ($event: any) => (onTypeCommand(it))
                }, _toDisplayString(it), 11, _hoisted_8))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(ElIcon), null, {
                default: _withCtx(() => [
                  _createVNode(_component_WarningFilled)
                ]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" 回收站中的资源超过30天会自动删除", -1))
            ])),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: onSceneCommand,
            "popper-class": "filter-popper",
            onVisibleChange: _cache[2] || (_cache[2] = ($event: any) => (scenesVisible.value = $event))
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scenes.value, (it) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: it.id,
                      command: it
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(it.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["command"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["filter-ref", { open: scenesVisible.value, 'filter-refActive': activeScenes.value.id != '' }])
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "分类", -1)),
                (activeScenes.value.id != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "：" + _toDisplayString(activeScenes.value.name), 1))
                  : _createCommentVNode("", true),
                _createVNode(_unref(ElIcon), { class: "caret" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDown))
                  ]),
                  _: 1
                }),
                (activeScenes.value.id != '')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "clear",
                      onClick: _withModifiers(clearScenes, ["stop"])
                    }, [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Close)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: onFormatCommand,
            "popper-class": "filter-popper",
            onVisibleChange: _cache[3] || (_cache[3] = ($event: any) => (formatsVisible.value = $event))
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formats.value, (it) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: it,
                      command: it
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(it), 1)
                      ]),
                      _: 2
                    }, 1032, ["command"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["filter-ref", { open: formatsVisible.value, 'filter-refActive': activeFormats.value !== '全部' }])
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "格式", -1)),
                (activeFormats.value !== '全部')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "：" + _toDisplayString(activeFormats.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(_unref(ElIcon), { class: "caret" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDown))
                  ]),
                  _: 1
                }),
                (activeFormats.value !== '全部')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "clear",
                      onClick: _withModifiers(clearFormats, ["stop"])
                    }, [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Close)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: onTagCommand,
            "popper-class": "filter-popper",
            "hide-on-click": false,
            onVisibleChange: _cache[4] || (_cache[4] = ($event: any) => (tagsVisible.value = $event))
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (it) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: it.id,
                      command: it,
                      class: _normalizeClass({ active: activeTags.value.findIndex((item) => item.id == it.id) >= 0 })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(it.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["command", "class"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["filter-ref", { open: tagsVisible.value, 'filter-refActive': activeTags.value.length }])
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "标签", -1)),
                (activeTags.value.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "：" + _toDisplayString(activeTagsLabel.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(_unref(ElIcon), { class: "caret" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDown))
                  ]),
                  _: 1
                }),
                (activeTags.value.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "clear",
                      onClick: _withModifiers(clearTags, ["stop"])
                    }, [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Close)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(ResourceMasonry, {
        ref_key: "materialRef",
        ref: materialRef,
        "show-upload-when-empty": true,
        onUpload: handleUpload
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(MultipleChoice, {
        onRefresh: refresh,
        activeFolder: activeFolder.value
      }, null, 8, ["activeFolder"])
    ])
  ]))
}
}

})